import { useStoreValue } from '@core'
import { getAppContext } from 'src/context/AppContext'

export const useUser = () => useStoreValue(getAppContext().user.store)
